"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _amb = _interopRequireDefault(require("./amb.Logger"));

var _amb2 = require("./amb.Constants");

var _excluded = ["callback"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CancelTransactionSender = function CancelTransactionSender() {
  var LOGGER = new _amb.default('amb.CancelTransactionSender');
  var ambCancelTransactionSender = {};
  var transactionCancelCallbacks = new Map();
  var batchSize = 10;
  var cancelTransactionChannel = null;
  var isSubscribed = false;

  function _validateRequest(request) {
    var result = {
      isValid: true,
      error: null
    };

    if (!request) {
      LOGGER.debug("empty cancel request");
      result.isValid = false;
      result.error = _amb2.MISSING_REQUEST_DATA;
      return result;
    }

    if (!request.hasOwnProperty("nowUiInteraction") || typeof request.nowUiInteraction !== "string") {
      LOGGER.debug("nowUiInteraction is unavailable or invalid");
      result.isValid = false;
      result.error = _amb2.MISSING_INTERACTION_ID;
      return result;
    }

    if (transactionCancelCallbacks.has(request.nowUiInteraction)) {
      LOGGER.debug("Transaction has already been submitted for cancellation. nowUiInteraction: " + request.nowUiInteraction);
      result.isValid = false;
      result.error = _amb2.TRANSACTION_ALREADY_SUBMITTED;
      return result;
    }

    return result;
  }

  function _getCallbackParams(request, response) {
    var callbackParams = {};
    callbackParams.request = request;
    callbackParams.request.action = _amb2.CANCEL_TRANSACTION_ACTION;
    callbackParams.response = response;
    return callbackParams;
  }

  function _executeCallbackForInvalidRequest(request, errorMessage) {
    if (!(request !== null && request !== void 0 && request.callback)) return;

    var callback = request.callback,
        requestWithoutCallback = _objectWithoutProperties(request, _excluded);

    var errorResponse = {
      successful: false,
      status: errorMessage
    };
    callback(_getCallbackParams(requestWithoutCallback, errorResponse));
  }

  function _executeCallback(nowUiInteraction, callbackParams) {
    if (!transactionCancelCallbacks.has(nowUiInteraction)) return;
    transactionCancelCallbacks.get(nowUiInteraction)(callbackParams);
    transactionCancelCallbacks.delete(nowUiInteraction);
  }

  function _handleCancelResponse(response) {
    var _response$ext$result;

    if (!response) {
      LOGGER.addWarnMessage("Empty response for cancel request");
      return;
    }

    if (!response.data || !response.ext || !response.ext.status) {
      LOGGER.addWarnMessage("Invalid response for cancel request");
      return;
    }

    if (response.ext.status === _amb2.REQUEST_ACCEPTED) {
      LOGGER.debug("Batch Cancel Request accepted");
      return;
    }

    if (response.ext.status === _amb2.REQUEST_SUCCESS && ((_response$ext$result = response.ext.result) === null || _response$ext$result === void 0 ? void 0 : _response$ext$result.length) !== response.data.length) {
      LOGGER.addWarnMessage("Invalid response for cancel request");
      return;
    }

    response.data.forEach(function (cancelRequest, index) {
      if (!cancelRequest.hasOwnProperty("nowUiInteraction")) return;
      var individualCancelResponse = response.ext.status === _amb2.REQUEST_SUCCESS ? response.ext.result[index] : response.ext;

      var callbackParams = _getCallbackParams(cancelRequest, individualCancelResponse);

      _executeCallback(cancelRequest.nowUiInteraction, callbackParams);
    });
  }

  function _handlePublishResponse(batchRequest, response) {
    if (response.successful) return;
    var publishFailureResponse = {
      successful: false,
      status: _amb2.PUBLISH_FAILURE
    };
    batchRequest.forEach(function (request) {
      _executeCallback(request.nowUiInteraction, _getCallbackParams(request, publishFailureResponse));
    });
  }

  function _subscribeToCancelTransactionChannel(messageClient) {
    cancelTransactionChannel = messageClient.getChannel(_amb2.CANCEL_TRANSACTION_CHANNEL);
    cancelTransactionChannel.subscribe(_handleCancelResponse);
    isSubscribed = true;
  }

  ambCancelTransactionSender.cancelTransaction =
  /* void */
  function (cancelTransactionRequests, messageClient) {
    LOGGER.debug('cancelTransaction');
    if (!isSubscribed) _subscribeToCancelTransactionChannel(messageClient);

    if (!cancelTransactionRequests || cancelTransactionRequests.length === 0) {
      LOGGER.addWarnMessage("Request array is empty or not defined");
      return;
    }

    var cancelRequestsWithoutCallback = [];
    cancelTransactionRequests.forEach(function (cancelTransactionRequest) {
      var result = _validateRequest(cancelTransactionRequest);

      if (!result.isValid) {
        _executeCallbackForInvalidRequest(cancelTransactionRequest, result.error);

        return;
      }

      var nowUiInteraction = cancelTransactionRequest.nowUiInteraction,
          callback = cancelTransactionRequest.callback;
      cancelRequestsWithoutCallback.push({
        nowUiInteraction: nowUiInteraction
      });
      if (callback) transactionCancelCallbacks.set(cancelTransactionRequest.nowUiInteraction, callback);
    });

    if (cancelRequestsWithoutCallback.length === 0) {
      LOGGER.debug("All requests filtered due to invalid inputs");
      return;
    }

    var _loop = function _loop(batchStart) {
      var batchedRequest = cancelRequestsWithoutCallback.slice(batchStart, batchStart + batchSize);
      cancelTransactionChannel.publish(batchedRequest, function (response) {
        return _handlePublishResponse(batchedRequest, response);
      });
    };

    for (var batchStart = 0; batchStart < cancelRequestsWithoutCallback.length; batchStart += batchSize) {
      _loop(batchStart);
    }
  };

  return ambCancelTransactionSender;
};

var _default = CancelTransactionSender;
exports.default = _default;